// covered-by: frontends/carrie/src/routes/ask-puntt/components/__tests__/ArtifactPaneCloseButton.test.tsx
import { X } from "@phosphor-icons/react";

/**
 * Leading close control shared by project review screens and standalone chat
 * artifact viewers (matches campaign review pane).
 */
export function ArtifactPaneCloseButton({
  onClick,
  "data-testid": testId = "chat-artifact-viewer-close",
  ariaLabel,
}: {
  onClick: () => void;
  "data-testid"?: string;
  ariaLabel: string;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      aria-label={ariaLabel}
      data-testid={testId}
      className="flex size-8 shrink-0 items-center justify-center rounded-md text-puntt-neutral-gray-11 transition-colors hover:bg-puntt-neutral-gray-3 hover:text-puntt-neutral-gray-12"
    >
      <X size={18} aria-hidden="true" />
    </button>
  );
}
